import React from 'react';
import SvgIcon from '../../SvgIcon';
export default function createSvgIcon(path, displayName) {
  var Component = React.memo(function (props) {
    return React.createElement(SvgIcon, props, path);
  });

  if (process.env.NODE_ENV !== 'production') {
    Component.displayName = "memo(".concat(displayName, ")");
  }

  Component.muiName = SvgIcon.muiName;
  return Component;
}